'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('AssessmentsCtrl', AssessmentsCtrl);

  AssessmentsCtrl.$inject = ['$state', '$log', '$translate', 'user', 'assessmentResponses', 'highchartsAssessmentConf', 'msAuth', '$mdDialog', 'assessmentResponsesNested', '$translate'];

  /* @ngInject */
  function AssessmentsCtrl($state, $log, $translate, user, assessmentResponses, highchartsAssessmentConf, msAuth, $mdDialog, assessmentResponsesNested) {
    var vm = this;
    vm.user = user;
    vm.title = 'AssessmentsCtrl';
    vm.isAssessmentResponses = assessmentResponses.length;
    vm.assessmentResponses = assessmentResponses;
    vm.assessmentResponsesNested = assessmentResponsesNested;

    vm.assessmentResponsesNested = assessmentResponsesNested.filter(function (assessmentResponse) {
      return assessmentResponse.activityType.name === 'QUESTIONNAIRE';
    });

    vm.assessmentResponsesNested.forEach(function (response) {
      response.completedOnDisplayName = moment(response.completedOn.datetime).format('ll');
    });

    vm.hasAdminPermission = msAuth.hasPermission('ADMIN');

    vm.currentNavItem = $state.current.name;

    var Highcharts = null;
    if (window && window.Highcharts) {
      Highcharts = window.Highcharts;
    }
    Highcharts.setOptions({
      lang: {
        months: moment.months(),
        weekdays: moment.weekdays(),
        shortMonths: moment.monthsShort()
      }
    });
    var dashStylesIterator = 0;
    var dashStyles = ['Solid', 'ShortDash', 'ShortDot', 'ShortDashDot', 'ShortDashDotDot', 'Dot', 'Dash', 'LongDash', 'DashDot', 'LongDashDot', 'LongDashDotDot'];

    activate();

    vm.assessmentResponsesFiltered = [];

    var combinedScores = [];
    var highchartSeries = [];

    vm.chartOptions = highchartsAssessmentConf;
    // Set translations to the Chart
    vm.chartOptions.title.text = '';

    $translate.onReady(function () {
      var scoreSring = $translate.instant('common.miscWords.score') !== 'common.miscWords.score' ? $translate.instant('common.miscWords.score') : 'Score';
      var dateString = $translate.instant('common.miscWords.date') !== 'common.miscWords.date' ? $translate.instant('common.miscWords.date') : 'Date';

      vm.chartOptions.accessibility.point.descriptionFormatter = function (p) {
        return p.series.name + ', ' + scoreSring + ': ' + p.y + ', ' + dateString + ': ' + moment(p.x).format('LLL');
      };

      vm.chartOptions.tooltip.pointFormat = scoreSring + ': {point.y} <br />' + dateString + ': {point.x:%b %e}';

      vm.chartOptions.yAxis.title.text = scoreSring;
    });

    // Combine the Category scores across each assessment.
    assessmentResponses.forEach(function (assessment) {
      var scores = scoreAssessment(assessment);

      Object.keys(scores).forEach(function (category) {
        if (combinedScores[category]) {
          combinedScores[category].data.push(scores[category].data);
        } else {
          combinedScores[category] = {
            name: scores[category].name,
            data: [scores[category].data]
          };
        }
      });

      vm.assessmentResponsesFiltered = _.values(combinedScores);
    });

    _.forEach(vm.assessmentResponsesFiltered, function (value) {
      if (value && value.data) {
        var dataSorted = _.sortBy(value.data, function (el) {
          return el[0];
        });
        highchartSeries.push({
          name: value.name,
          data: dataSorted,
          dashStyle: getNextDashStyle()
        });
      }
    });

    vm.chartOptions.series = highchartSeries;

    // Get the score for each category in Assessment.
    function scoreAssessment(assessment) {
      var mapScores = {};

      _.map(assessment.scores, function (value, key) {
        var categoryScore = {
          name: '',
          data: [moment(assessment.completedOn.datetime).valueOf(), Math.abs(parseInt(value))]
        };

        var matchedCategory = assessment.questionCategories.filter(function (category) {
          return category.id === parseInt(key);
        })[0];

        categoryScore.name = matchedCategory.name;
        mapScores[categoryScore.name] = categoryScore;
      }, 0);

      return mapScores;
    }

    ////////////////

    function activate() {
      $log.debug('Assessments control activate');
      vm.responses = assessmentResponses;
      // workaround for md-nav-bar for accessibility
      var navElement = angular.element(document.querySelector('._md-nav-bar-list'));
      navElement.attr('tabindex', '0');
    }

    function getNextDashStyle() {
      if (dashStylesIterator > dashStyles.length + 1) {
        dashStylesIterator = 0;
      }
      return dashStyles[dashStylesIterator++];
    }

    vm.collapseAll = function (data) {
      for (var i in vm.assessmentResponsesNested) {
        if (vm.assessmentResponsesNested[i] != data) {
          vm.assessmentResponsesNested[i].expanded = false;
        }
      }
      data.expanded = !data.expanded;
    };

    vm.showLegend = function (ev, template) {
      if (template) {
        var modalTemplate = '<md-dialog ms-keep-focus-here aria-label="' + $translate.instant('vnext.modals.modal') + '">\n      <md-toolbar>\n        <div class="md-toolbar-tools history-modal-header">\n          <h2 tabindex="-1" id="modal-title">' + $translate.instant('vnext.modals.information') + '</h2>\n          <span flex></span>\n          <md-button class="md-icon-button" ng-click="cancel()" aria-label="' + $translate.instant('vnext.modals.close') + '">\n            <i class="fa fa-close"></i>\n          </md-button>\n        </div>\n      </md-toolbar>\n        <section class="history-modal-body">\n          ' + template + '\n        </section>\n      </md-dialog>';

        $mdDialog.show({
          controller: DialogController,
          template: modalTemplate,
          // Appending dialog to document.body to cover sidenav in docs app
          // Modal dialogs should fully cover application to prevent interaction outside of dialog
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: false // Only for -xs, -sm breakpoints.
        }).then(function (answer) {
          vm.status = 'You said the information was "' + answer + '".';
        }, function () {
          vm.status = 'You cancelled the dialog.';
        });

        focus.byId('modal-title', 100);
      }
    };
  }

  angular.module('vnext').controller('DialogController', DialogController);

  DialogController.$inject = ['$scope', '$mdDialog'];

  function DialogController($scope, $mdDialog) {
    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.answer = function (answer) {
      $mdDialog.hide(answer);
    };
  }
})();